var _defs, _polygon, _polygon2, _polygon3, _polygon4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 389.83 389.83",
    style: {
      fill: "#ffffff"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        fill: #64b273;\n      }\n\n      .cls-3 {\n        fill: #eaa13b;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 389.83,
    height: 389.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 389.83,
    height: 389.83
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 257.79 319.45 96.49 309.08 69.06 380.75 75.35 346.8 144.51 334.23 119.36 7.27 289.12 0 257.79"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "89.35 56.59 139.31 56.48 150.9 93.9 76.44 94.21 89.35 56.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.3 96.49 37.73 131.63 113.18 131.63 100.79 96.49 50.3 96.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "160.42 94.21 176.05 96.49 190.95 131.63 116.06 131.63 124.22 96.49 160.42 94.21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.97,182.34c0-3.47-2.82-6.29-6.29-6.29h-37.73c-3.47,0-6.29,2.82-6.29,6.29v194.92h-50.3v-150.9c0-3.47-2.82-6.29-6.29-6.29h-37.73c-3.47,0-6.29,2.82-6.29,6.29v150.9h-50.3v-94.31c0-3.47-2.82-6.29-6.29-6.29h-37.73c-3.47,0-6.29,2.82-6.29,6.29v94.31h-50.3v-44.01c0-3.47-2.82-6.29-6.29-6.29H25.15c-3.47,0-6.29,2.82-6.29,6.29v44.01H0v12.58h389.83v-12.58h-18.86v-194.92Zm-37.73,6.29h25.15v188.63h-25.15v-188.63Zm-100.6,44.01h25.15v144.61h-25.15v-144.61Zm-100.6,56.59h25.15v88.03h-25.15v-88.03Zm-100.6,50.3h25.15v37.73h-25.15v-37.73Zm6.29-201.2h150.9c2.01,0,3.91-.98,5.11-2.6,1.18-1.65,1.5-3.76.86-5.67l-12.58-37.73c-.86-2.56-3.26-4.3-5.97-4.3h-20.63l-11.13-33.42c-.86-2.56-3.26-4.3-5.97-4.3h-50.3c-2.7,0-5.11,1.74-5.97,4.3l-11.13,33.42h-20.63c-2.7,0-5.11,1.74-5.97,4.3l-12.57,37.73c-.64,1.91-.32,4.02.86,5.67,1.2,1.62,3.09,2.6,5.11,2.6h0Zm75.45-26.16l-3.85-11.57h7.71l-3.85,11.57Zm66.73,13.58h-58.01l8.4-25.15h41.21l8.4,25.15Zm-87.33-62.88h41.21l8.4,25.15h-58.01l8.4-25.15Zm-37.73,37.73h41.21l8.4,25.15h-58.01l8.4-25.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    width: 12.58,
    height: 25.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.48,
    y: 44.01,
    width: 25.15,
    height: 12.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.73,
    y: 44.01,
    width: 25.15,
    height: 12.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.57,
    y: 15.72,
    width: 22.67,
    height: 12.58,
    transform: "translate(48.89 135.36) rotate(-56.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 10.67,
    width: 12.58,
    height: 22.67,
    transform: "translate(.47 45.58) rotate(-33.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.02,294.61c1.87,1.13,4.2,1.23,6.17.23l322.53-166.7,8.35,18.98c.96,2.21,3.07,3.68,5.48,3.79,2.38.08,4.62-1.18,5.8-3.27l37.73-69.16c1.01-1.86,1.01-4.13,0-6.02-1-1.86-2.9-3.09-5.04-3.26l-75.45-6.29c-2.23-.19-4.37.81-5.67,2.63-1.3,1.82-1.52,4.17-.62,6.21l9.43,21.1L3.39,252.19c-2.09,1.08-3.39,3.24-3.39,5.6v31.44c0,2.19,1.13,4.22,3.02,5.38h0Zm9.56-32.99L322.86,101.29c2.97-1.55,4.24-5.13,2.87-8.17l-7.56-16.83,55.24,4.62-26.94,49.44-5.9-13.38c-.69-1.6-2.01-2.83-3.66-3.41-1.62-.59-3.44-.47-4.99.34L12.58,278.89v-17.27Zm0,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg47);
export default __webpack_public_path__ + "static/media/47.2ee8f880c8dfe1f5ffd18bedb3b9ec0f.svg";
export { ForwardRef as ReactComponent };